const state = {
    form: null,
    score: null,
    review: null,
    reviewSuggestion: null,
    showRating: false,
    showForm: false,
    showOptions: false,
    success: false,
    copied: false,
    selectingLocation: false,
}

const getters = {

    form: state => {
        return state.form;
    },

    score: state => {
        return state.score;
    },

    review: state => {
        return state.review;
    },

    reviewSuggestion: state => {
        return state.reviewSuggestion;
    },

    showRating: state => {
        return state.showRating;
    },

    showForm: state => {
        return state.showForm;
    },

    showOptions: state => {
        return state.showOptions;
    },

    success: state => {
        return state.success;
    },

    copied: state => {
        return state.copied;
    },

    selectingLocation: state => {
        return state.selectingLocation;
    },

}

const mutations = {

    setForm(state, form) {
        state.form = form;
    },

    setScore(state, score) {
        state.score = score;
    },

    setReview(state, review) {
        state.review = review;
    },

    setReviewSuggestion(state, reviewSuggestion) {
        state.reviewSuggestion = reviewSuggestion;
    },

    setShowRating(state, showRating) {
        state.showRating = showRating;
    },

    setShowForm(state, showForm) {
        state.showForm = showForm;
    },

    setShowOptions(state, showOptions) {
        state.showOptions = showOptions;
    },

    setSuccess(state, success) {
        state.success = success;
    },

    setCopied(state, copied) {
        state.copied = copied;
    },

    setSelectingLocation(state, selectingLocation) {
        state.selectingLocation = selectingLocation;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}